import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/Container/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ActionButton"] */ "/vercel/path0/packages/website/src/app/components/buttons/ActionButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Title"] */ "/vercel/path0/packages/website/src/app/components/typography/Title.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/website/src/app/components/utility/SlideUpAnimation.tsx");
